import { useEffect, type RefObject } from 'react';

// Invokes the callback when a pointerdown lands outside every ref. Refs whose
// current is null are ignored -- mount order doesn't need to match the consumer.
// Uses pointerdown (not click) so dragging out of the element doesn't miss-
// trigger, matching the MasterGrid budget cell's popover feel.
export function useClickOutside(
  refs: Array<RefObject<HTMLElement | null>>,
  onOutside: () => void,
  enabled: boolean = true,
): void {
  useEffect(() => {
    if (!enabled) return;
    const handler = (e: PointerEvent) => {
      const target = e.target as Node | null;
      if (!target) return;
      for (const ref of refs) {
        const el = ref.current;
        if (el && el.contains(target)) return;
      }
      onOutside();
    };
    document.addEventListener('pointerdown', handler);
    return () => document.removeEventListener('pointerdown', handler);
    // refs is usually a stable array from the caller; we intentionally only
    // re-bind when the callback or enabled flag changes. If the caller's ref
    // set actually changes they should toggle `enabled`.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onOutside, enabled]);
}
